<template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <h1 class="titulo">Liquidação de contratos</h1>
      <v-row>
        <v-col cols="12" class="py-0">
          <ExpansionPanelDefault :handleClick="montarLabelFiltro">
          <v-row class="justify-end">
            <v-col cols="12" md="2">
              <v-text-field
                append-icon="search"
                :label="'CPF'"
                single-line
                hide-details
                v-on:keyup.enter="buscarPorEntidade"
                v-model="textSearch"
                v-mask="['###.###.###-##']"
                color="primary"
                solo
                dense
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                v-model="tipoStatus"
                :items="tiposStatus"
                label="Selecionar estado"
                dense
                item-text="text"
                item-value="value"
                hide-details
                solo
                class="select-status"
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="3">
              <DateModal 
                :dates.sync="data"
                :maxDateRange="30"
                
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                type="submit"
                :color="variables.colorPrimary"
                @click.prevent="submit"
                class="br-btn"
                :loading="loading">Processar</v-btn>

            </v-col>
          </v-row>
        </ExpansionPanelDefault>
        </v-col>
        <!-- <v-col cols="12" class="py-0">
          <v-card class="py-0">
            <v-card-text class="modal-cadastro-form pa-3 pb-1">
              <v-row class="align-end justify-space-between">
                <v-col class="d-flex justify-end py-0">
                  <v-card 
                    :color="variables.colorPrimary"
                    elevation="0"
                    rounded="0"
                    class="box-total"
                    dark> Total: </v-card>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="modal-cadastro-footer pt-0">
              
              <v-btn
                type="submit"
                v-if="selected.length"
                dark
                :color="variables.colorSuccess"
                @click.prevent="fecharLiquidacaoSelecionadas"
                :loading="loadingFechamento">Fechar Liquidações Selecionadas</v-btn>

              <v-btn
                v-if="transmissoes.results.length"
                :color="variables.colorSecondary"
                @click.prevent="handleDownload"
                class="br-btn br-btn-cancelar"
                >Baixar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
      </v-row>

      <div class="box-table box-table-gecom">
        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            class="mt-4"
            :headers="headers"
            :search="search"
            :items="listaItens"
            width="300px"
            flat
            :expanded.sync="expanded"
            v-model="selected"
            hide-default-footer
            :loading="loadingPag"
            :show-select="false"
            :items-per-page.sync="itemsPerPage"
            @toggle-select-all="selectAllToggle"
            item-key='partnerEntityId'
          >

            <template v-slot:item.affiliateContract.payIntervalType="{ item }">
              {{ typesInterval[item.affiliateContract.payIntervalType]  }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ tiposStatus.find(it => it.value === item.status).text   }}
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn
                class="btn-fechar-liquidacao mr-2"
                :loading="loadingFechamento"
                :color="variables.colorSuccess"
                dark
                :disabled="item.desabilitarFechamento || item.semComisao"
                @click="fecharLiquidacao(item)"
              >
                {{ item.semComisao ? 'Sem Comissão' : item.desabilitarFechamento ? 'Lançado' : 'Fechar Liquidação' }} 
              </v-btn>
              <v-btn
                class="btn-fechar-liquidacao"
                :loading="loadingFechamento"
                :color="variables.colorError"
                dark
                v-if="!(item.desabilitarFechamento || item.semComisao)"
                @click="abrirModalRejetar(item)"
              >
                Rejeitar 
              </v-btn>
            </template>
            
            <!-- <template slot="body.append">
              <tr>
                <th></th>
                <th></th>
                <th class="text-end">Total</th>
                <th class="text-end">{{ getTotalGeral('proposta') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('comissao') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('premiosRevendaTickets') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('pendingPrizes') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('premiosTicketAltos') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('premioWeb') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('premioPix') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('lp') | currencyNoSymbol }}</th>
                <th class="text-center"> - </th>
                <th class="text-end">{{ getTotalGeral('participacaoNgr') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('participacaoBonus') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('participacaoVendaBruta') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeralSemNegativos('total') | currencyNoSymbol }}</th>
                <th class="text-end">{{ getTotalGeral('totalOld') | currencyNoSymbol }}</th>
                <th></th>
              </tr>
            </template> -->

            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="7"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>
    </v-container>

    <ModalRejetarComissao 
      :data="dataContractSettlements"
      :isOpenModal="isOpenModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import moment from 'moment'
import { currency } from '@/core/service/utils'
// import {cloneDeep} from 'lodash'
import Events from '@/core/service/events'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

const namespaceStore = 'liquidacaoContratos'

export default {
  name: 'LiquidacaoContratosAfiliados',
  components: {
    // rangeDate: () => import('../../components/rangeDateParceiros'),
    DateModal: () => import('./components/dateModal'),
    ModalRejetarComissao: () => import('./components/modalRejetarComissao'),
    ExpansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
  },
  mixins: [listagemTables],
  data: () => ({
    loading: false,
    loadingFechandoLiquidacoes: false,
    loadingFechamento: false,
    loadingTable: false,
    data: [moment().add(-7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    textSearch: '',
    selected: [],
    expanded: [],
    headers: [
      // { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'CPF', value: 'affiliate.entity.jsonData.cpf' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'affiliate.entity.jsonData.fullName' },
      { align: 'start', class: 'table-header', text: 'Comissão', value: 'comissionValue' },
      { align: 'start', class: 'table-header', text: 'Tipo de Comissão', value: 'affiliateContract.contract.contractTypeId' },
      { align: 'start', class: 'table-header', text: 'dt. Inicio', value: 'periodStart' },
      { align: 'start', class: 'table-header', text: 'dt. Final', value: 'periodEnd' },
      { align: 'start', class: 'table-header', text: 'Tipo Intervalo', value: 'affiliateContract.payIntervalType' },
      { align: 'start', class: 'table-header', text: 'Intervalo', value: 'affiliateContract.payIntervalQty' },
      { align: 'start', class: 'table-header', text: 'Status', value: 'status' },
      { align: 'start', class: 'table-header', text: '', value: 'action' },
    ],
    tiposStatus: [
      { text: 'Todos', value: '' },
      { text: 'Novo', value: 'N' },
      { text: 'Pago', value: 'P' },
      { text: 'Fechado', value: 'F' },
      { text: 'Rejeitado', value: 'R' },
    ],
    tipoStatus: 'N',
    isOpenModal: false,
    dataContractSettlements: undefined
  }),

  watch: {
    tipoStatus () {
      this.getData()
    }
  },

  mounted () {
    this.getData()
  },

  computed: {
    ...mapGetters(namespaceStore, ['listaItens', 'totalItens']),
    ...mapGetters('auth', ['user']),
    typesInterval ()  {
      return {
        'DAY': 'Dias'
      }
    }
  },

  methods: {
    ...mapActions(namespaceStore, ['getItens', 'limparTabela', 'fecharLiquidacoes']),

    clearDados () {
      this.clearItens()
    },

    init() {},

    getData () {
      this.loadingTable = true
      this.getItens({ 
        page: this.page,
        status: this.tipoStatus,
        dtStart: this.data[0], 
        dtEnd: this.data[1],
        pageSize: this.$store.getters.ItensPaginacao,
      })
      .catch(err => {
        console.log(err)
        errorSnackbar(err.error)
      })
      .finally(() => this.loadingTable = false)
    },

    closeModal (v) {
      if (v) {
        this.getData()
      }

      this.isOpenModal = false
      this.dataContractSettlements = undefined
    },

    submit () {
      this.getData()
    },

    abrirModalRejetar (e) {
      this.isOpenModal = true
      this.dataContractSettlements = e
    },

    // getTotal (data) {
    //   return data.participacaoNgr + data.participacaoBonus + data.participacaoVendaBruta
    // },

    // getTotalGeral (campo) {
    //   return this.listaItens.length ? this.listaItens.reduce((total, item) => total + item[campo], 0) : 0
    // },

    // getTotalGeralSemNegativos (campo) {
    //   return this.listaItens.length ? this.listaItens.reduce((total, item) => total + (item[campo] > 0 ? item[campo] : 0), 0) : 0
    // },

    fecharLiquidacao (data) {
      const settlements = [{
        contractSettlementId: data.id,
        entityId: data.affiliate.entityId,
        value: data.comissionValue
      }]

      const msg = settlements.length > 1 ? 
        `Tem certeza que deseja fechar a liquidação` :
        `Tem certeza que deseja fechar a liquidacao do ${data.affiliate.entity.jsonData.fullName} no valor de ${currency(data.comissionValue)}`  

      this.$swal({
        icon: 'warning',
        text: msg,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.loadingFechamento = true
          this.fecharLiquidacoes({settlements})
          .then(() => { 
            successSnackbar('Fechamento Liquidação realizado com sucesso') 
            this.getData()
          })
          .catch((e) => errorSnackbar(e))
          .finally(() => this.loadingFechamento = false)
        }
      })
    },

    fecharLiquidacaoSelecionadas () {
      if (!this.selected.length) return
      const partners = this.selected.map(it => ({
        entityContractId: it.entityContractId,
        partnerEntityId: it.partnerEntityId,
        value: it.total,
        valueOld: it.total_old ? parseFloat(it.total_old.toFixed(2)) : undefined,
        dtRefMonth: it.dtRefMonth
      }))
      const totalGeral = partners.reduce((total, item) => total + item.value, 0)
      this.$swal({
        icon: 'warning',
        text: `Tem certeza que deseja fechar a liquidação ${currency(totalGeral)}?`,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.loadingFechamento = true
          this.fecharLiquidacoes({partners})
          .then(() => { 
            successSnackbar('Fechamento Liquidação realizado com sucesso') 
            this.submit()
          })
          .catch((e) => errorSnackbar(e))
          .finally(() => this.loadingFechamento = false)
        }
      })
    },

    salvarNovoTotal(dados, novoTotal) {
      if (dados.total !== parseFloat(novoTotal)) {
        dados.total_old = dados.total
        dados.total = parseFloat(novoTotal)
      }
      return
    },

    abrirFormAlterarTotal(total) {
      this.novoTotal = total.toFixed(2)
    },

    fecharFormAlterarTotal() {
      this.novoTotal = 0
    },

    selectAllToggle(props) {
      const totalDesabilitado = this.listaItens.reduce((acc, item) => item.desabilitarFechamento ? acc + 1 : acc + 0, 0)
      if(this.selected.length != this.listaItens.length - totalDesabilitado) {
        this.selected = [];
        props.items.forEach(item => {
          if(!item.desabilitarFechamento) {
            this.selected.push(item);
          } 
        });
      } else this.selected = []
    },

    limparDados () {
      this.selected = []
      this.limparTabela()
    },

    montarLabelFiltro(){     
      Events.$on('autoCompleteEntities::getSearchText', (val)=>{ this.terminalTextSelected = val })
      let labelFiltro = [
      {
          label: 'Data Inicial:',
          value: moment(this.rangeDate.start).format('DD/MM/YYYY')
        },
        {
          label: 'Data Final:',
          value: moment(this.rangeDate.end).format('DD/MM/YYYY')
        },
    ]
      // codBilhete, entity
      return labelFiltro
    },
  },

  beforeDestroy () {
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {
    // border-top: 5px solid $colorPrimary;
    // border-top-left-radius: 0 !important;
    // border-top-right-radius: 0 !important;

    .v-data-table-header-mobile {
      display: none;
    }

    &.box-table-gecom {
      .v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
        height: auto;
        padding: 5px;
        font-size: 11px;
      }
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }

  .btn-fechar-liquidacao.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #b5b5b5 !important;
    color: #262626 !important;
  }

  .box-total {
    padding: 10px !important;
    background-color: #f07d0a !important;
  }
</style>>
